// @flow
import React from 'react';
import { Box, Text } from 'gestalt';

export type Step = {|
  number: number,
  header: string,
  body: string,
|};

type Props = {|
  isPromotedSection?: boolean,
  educationSteps: Array<Step>,
|};

const EducationModules = ({ isPromotedSection, educationSteps }: Props) => (
  <React.Fragment>
    {educationSteps.map(({ number, header, body }: Step) => (
      <Box key={number} flex="grow" dangerouslySetInlineStyle={{ __style: { flexBasis: 0 } }}>
        <Box
          shape="circle"
          color={isPromotedSection ? 'lightGray' : 'blue'}
          width={54}
          height={54}
          display="flex"
          marginBottom={3}
          justifyContent="center"
          alignItems="center"
        >
          <Text color={isPromotedSection ? 'darkGray' : 'white'} size="xl" weight="bold">
            {number}
          </Text>
        </Box>
        <Text size="lg" weight="bold">
          {header}
        </Text>
        <Box marginRight={2}>
          <Text overflow="normal">{body}</Text>
        </Box>
      </Box>
    ))}
  </React.Fragment>
);

export default EducationModules;
